export default __webpack_public_path__ + "static/media/figma.8a91ae61.png";